import { NegotiationType } from './enums.lib'

export const negotiationTypesValues = [
  { code: NegotiationType.ON_SPOT, text: 'On spot' },
  { code: NegotiationType.NEXT_DAY, text: 'Next day' }
]

export const brazilianBanksData = [
  {
    name: 'Banco do Brasil',
    code: 'BANCO_DO_BRASIL'
  },
  {
    name: 'Banco Santander Brasil',
    code: 'SANTANDER'
  },
  {
    name: 'Caixa Econômica Federal',
    code: 'CAIXA_ECONOMICA_FEDERAL'
  },
  {
    name: 'Banestes - Banco do Estado do Espírito Santo',
    code: 'BANESTES'
  },
  {
    name: 'Banco do Estado do Pará',
    code: 'BANCO_DO_PARA'
  },
  {
    name: 'Banco do Estado do Rio Grande do Sul',
    code: 'BANCO_RIO_GRANDE_DO_SUL'
  },
  {
    name: 'Banco do Nordeste do Brasil',
    code: 'BANCO_NORDESTE_BRASIL'
  },
  {
    name: 'Banco Inter',
    code: 'BANCO_INTER'
  },
  {
    name: 'Banco Mizuho do Brasil',
    code: 'BANCO_MIZUHO'
  },
  {
    name: 'Banco Caixa Geral - Brasil',
    code: 'BANCO_CAIXA_GERAL'
  },
  {
    name: 'Crefisa',
    code: 'CREFISA'
  },
  {
    name: 'Itaú Unibanco',
    code: 'BANCO_ITAU'
  },
  {
    name: 'Banco BTG Pactual',
    code: 'BANCO_BTG_PACTUAL'
  },
  {
    name: 'Banco Mercantil do Brasil',
    code: 'BANCO_MERCANTIL_BRASIL'
  },
  {
    name: 'Banco Nacional de Desenvolvimento Econômico e Social',
    code: 'BNDES'
  },
  {
    name: 'Banco Safra',
    code: 'BANCO_SAFRA'
  },
  {
    name: 'Banco Société Générale Brasil',
    code: 'BANCO_SOCIETE_GENERALE'
  },
  {
    name: 'Banco Sumitomo Mitsui Brasileiro',
    code: 'BANCO_SUMITOMO'
  },
  {
    name: 'Banco ABC Brasil',
    code: 'BANCO_ABC'
  },
  {
    name: 'China Construction Bank (Brasil)',
    code: 'CHINA_CONSTRUCTION_BANK'
  },
  {
    name: 'Banco Paulista',
    code: 'BANCO_PAULISTA'
  },
  {
    name: 'Banco Fibra',
    code: 'BANCO_FIBRA'
  },
  {
    name: 'Banco Votorantim',
    code: 'BANCO_VOTORANTIM'
  },
  {
    name: 'Banco Indusval',
    code: 'BANCO_INDUSVAL'
  },
  {
    name: 'Banco Rendimento',
    code: 'BANCO_RENDIMENTO'
  },
  {
    name: 'Banco Industrial do Brasil',
    code: 'BANCO_INDUSTRIAL'
  },
  {
    name: 'Banco Daycoval',
    code: 'BANCO_DAYCOVAL'
  },
  {
    name: 'Banco Rabobank International Brasil',
    code: 'BANCO_RABOBANK'
  },
  {
    name: 'Banco BNP Paribas Brasil',
    code: 'BNP_PARIBAS_BRASIL'
  },
  {
    name: 'Banco Citibank',
    code: 'CITIBANK'
  },
  {
    name: 'Banco Pine',
    code: 'BANCO_PINE'
  },
  {
    name: 'Banco Cooperativo Sicredi',
    code: 'BANCO_COOPERATIVO_SICREDI'
  },
  {
    name: 'Banco Alfa de Investimento',
    code: 'BANCO_ALFA'
  },
  {
    name: 'Banco Sofisa',
    code: 'BANCO_SOFISA'
  },
  {
    name: 'Banco Modal',
    code: 'BANCO_MODAL'
  },
  {
    name: 'Banco Intercap',
    code: 'BANCO_INTERCAP'
  },
  {
    name: 'Banco Bradesco',
    code: 'BANCO_BRADESCO'
  },
  {
    name: 'Nu Pagamentos (Nubank)',
    code: 'NUBANK'
  },
  {
    name: 'Banco Original',
    code: 'BANCO_ORIGINAL'
  },
  {
    name: 'ICBC do Brasil Banco Múltiplo',
    code: 'ICBC_BRASIL'
  },
  {
    name: 'HSBC Brasil',
    code: 'HSBC_BRASIL'
  }
]

export const argentinianBanksData = [
  {
    name: 'Banco de Galicia y Buenos Aires S.A.U.',
    code: 'BANCO_DE_GALICIA_Y_BUENOS_AIRES_SAU'
  },
  {
    name: 'Banco de la Nación Argentina',
    code: 'BANCO_DE_LA_NACION_ARGENTINA'
  },
  {
    name: 'Banco de la Provincia de Buenos Aires',
    code: 'BANCO_DE_LA_PROVINCIA_DE_BUENOS_AIRES'
  },
  {
    name: 'Industrial and Commercial Bank of China',
    code: 'INDUSTRIAL_AND_COMMERCIAL_BANK_OF_CHINA'
  },
  {
    name: 'Citibank N.A.',
    code: 'CITIBANK_NA'
  },
  {
    name: 'BBVA Banco Francés S.A.',
    code: 'BANCO_BBVA_ARGENTINA_SA'
  },
  {
    name: 'Banco de la Provincia de Córdoba S.A.',
    code: 'BANCO_DE_LA_PROVINCIA_DE_CORDOBA_SA'
  },
  {
    name: 'Banco Supervielle S.A.',
    code: 'BANCO_SUPERVIELLE_SA'
  },
  {
    name: 'Banco de la Ciudad de Buenos Aires',
    code: 'BANCO_DE_LA_CIUDAD_DE_BUENOS_AIRES'
  },
  {
    name: 'Banco Patagonia S.A.',
    code: 'BANCO_PATAGONIA_SA'
  },
  {
    name: 'Banco Hipotecario S.A.',
    code: 'BANCO_HIPOTECARIO_SA'
  },
  {
    name: 'Banco de San Juan S.A.',
    code: 'BANCO_DE_SAN_JUAN_SA'
  },
  {
    name: 'Banco Municipal de Rosario',
    code: 'BANCO_MUNICIPAL_DE_ROSARIO'
  },
  {
    name: 'Banco Santander Río S.A.',
    code: 'BANCO_SANTANDER_ARGENTINA_SA'
  },
  {
    name: 'Banco del Chubut S.A.',
    code: 'BANCO_DEL_CHUBUT_SA'
  },
  {
    name: 'Banco de Santa Cruz S.A.',
    code: 'BANCO_DE_SANTA_CRUZ_SA'
  },
  {
    name: 'Banco de La Pampa Sociedad de Economía Mixta',
    code: 'BANCO_DE_LA_PAMPA_SOCIEDAD_DE_ECONOMIA_MIXTA'
  },
  {
    name: 'Banco de Corrientes S.A.',
    code: 'BANCO_DE_CORRIENTES_SA'
  },
  {
    name: 'Banco Provincia del Neuquén S.A.',
    code: 'BANCO_PROVINCIA_DEL_NEUQUEN_SOCIEDAD_ANONIMA'
  },
  {
    name: 'Bank of China Limited Sucursal Buenos Aires',
    code: 'BANK_OF_CHINA_LIMITED_SUCURSAL_BUENOS_AIRES'
  },
  {
    name: 'Brubank S.A.U.',
    code: 'BRUBANK_SAU'
  },
  {
    name: 'Banco Interfinanzas S.A.',
    code: 'BIBANK_SA'
  },
  {
    name: 'HSBC Bank Argentina S.A.',
    code: 'HSBC_BANK_ARGENTINA_SA'
  },
  {
    name: 'Openbank',
    code: 'OPEN_BANK_ARGENTINA_SA'
  },
  {
    name: 'JP Morgan Chase Bank NA (Sucursal Buenos Aires)',
    code: 'JPMORGAN_CHASE_BANK_NATIONAL_ASSOCIATION'
  },
  {
    name: 'Banco Credicoop Cooperativo Limitado',
    code: 'BANCO_CREDICOOP_COOPERATIVO_LIMITADO'
  },
  {
    name: 'Banco de Valores S.A.',
    code: 'BANCO_DE_VALORES_SA'
  },
  {
    name: 'Banco Roela S.A.',
    code: 'BANCO_ROELA_SA'
  },
  {
    name: 'Banco Mariva S.A.',
    code: 'BANCO_MARIVA_SA'
  },
  {
    name: 'Banco Itaú Argentina S.A.',
    code: 'BANCO_ITAU_ARGENTINA'
  },
  {
    name: 'Bank of America National Association',
    code: 'BANK_OF_AMERICA_NATIONAL_ASSOCIATION'
  },
  {
    name: 'BNP Paribas',
    code: 'BNP_PARIBAS'
  },
  {
    name: 'Banco Provincia de Tierra del Fuego',
    code: 'BANCO_PROVINCIA_DE_TIERRA_DEL_FUEGO'
  },
  {
    name: 'Banco de la República Oriental del Uruguay',
    code: 'BANCO_DE_LA_REPUBLICA_ORIENTAL_DEL_URUGUAY'
  },
  {
    name: 'Banco Sáenz S.A.',
    code: 'BANCO_SAENZ_SA'
  },
  {
    name: 'Banco Meridian S.A.',
    code: 'BANCO_MERIDIAN_SA'
  },
  {
    name: 'Banco Macro S.A.',
    code: 'BANCO_MACRO_SA'
  },
  {
    name: 'American Express Bank LTD. S.A.',
    code: 'AMERICAN_EXPRESS_BANK_LTD'
  },
  {
    name: 'Banco Comafi S.A.',
    code: 'BANCO_COMAFI_SOCIEDAD_ANONIMA'
  },
  {
    name: 'Banco de Inversión y Comercio Exterior S.A.',
    code: 'BANCO_DE_INVERSION_Y_COMERCIO_EXTERIOR_SA'
  },
  {
    name: 'Banco Piano S.A.',
    code: 'BANCO_PIANO_SA'
  },
  {
    name: 'Banco Julio S.A.',
    code: 'BANCO_JULIO_SOCIEDAD_ANONIMA'
  },
  {
    name: 'Nuevo Banco de la Rioja S.A.',
    code: 'BANCO_RIOJA_SOCIEDAD_ANONIMA_UNIPERSONAL'
  },
  {
    name: 'Banco del Sol S.A.',
    code: 'BANCO_DEL_SOL_SA'
  },
  {
    name: 'Nuevo Banco del Chaco S.A.',
    code: 'NUEVO_BANCO_DEL_CHACO_S_A'
  },
  {
    name: 'MBA Lazard Banco de Inversiones S.A.',
    code: 'BANCO_VOII_SA'
  },
  {
    name: 'Banco de Formosa S.A.',
    code: 'BANCO_DE_FORMOSA_SA'
  },
  {
    name: 'Banco CMF S.A.',
    code: 'BANCO_CMF_SA'
  },
  {
    name: 'Banco de Santiago del Estero S.A.',
    code: 'BANCO_DE_SANTIAGO_DEL_ESTERO_SA'
  },
  {
    name: 'Banco Industrial S.A.',
    code: 'BANCO_INDUSTRIAL_SA'
  },
  {
    name: 'Deutsche Bank S.A.',
    code: 'DEUTSCHE_BANK_SA'
  },
  {
    name: 'Nuevo Banco de Santa Fe S.A.',
    code: 'NUEVO_BANCO_DE_SANTA_FE_SOCIEDAD_ANONIMA'
  },
  {
    name: 'Banco Cetelem Argentina S.A.',
    code: 'BANCO_CETELEM_ARGENTINA_SA'
  },
  {
    name: 'Banco de Servicios Financieros S.A.',
    code: 'BANCO_DE_SERVICIOS_FINANCIEROS_SA'
  },
  {
    name: 'Banco Bradesco Argentina S.A.',
    code: 'BANCO_BRADESCO_ARGENTINA_SA'
  },
  {
    name: 'Banco de Servicios y Transacciones S.A.',
    code: 'BANCO_DE_SERVICIOS_Y_TRANSACCIONES_SA'
  },
  {
    name: 'RCI Banque S.A.',
    code: 'RCI_BANQUE_SA'
  },
  {
    name: 'BACS Banco de Crédito y Securitización S.A.',
    code: 'BACS_BANCO_DE_CREDITO_Y_SECURITIZACION_SA'
  },
  {
    name: 'Más Ventas S.A.',
    code: 'BANCO_MASVENTAS_SA'
  },
  {
    name: 'Wilobank S.A.U.',
    code: 'WILOBANK_SAU'
  },
  {
    name: 'Nuevo Banco de Entre Ríos S.A.',
    code: 'NUEVO_BANCO_DE_ENTRE_RIOS_SA'
  },
  {
    name: 'Banco Columbia S.A.',
    code: 'BANCO_COLUMBIA_SA'
  },
  {
    name: 'Ford Credit Compañía Financiera S.A.',
    code: 'FORD_CREDIT_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'Metrópolis Compañía Financiera S.A.',
    code: 'METROPOLIS_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'Montemar Compañía Financiera S.A.',
    code: 'MONTEMAR_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'Transatlántica Compañía Financiera S.A.',
    code: 'TRANSATLANTICA_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'Banco Bica S.A.',
    code: 'BANCO_BICA_SA'
  },
  {
    name: 'Caja de Crédito Coop. La Capital del Plata LTDA.',
    code: 'CAJA_DE_CREDITO_COOP_LA_CAPITAL_DEL_PLATA_LTDA'
  },
  {
    name: 'Banco Coinag S.A.',
    code: 'BANCO_COINAG_SA'
  },
  {
    name: 'Banco de Comercio S.A.',
    code: 'BANCO_DE_COMERCIO_SA'
  },
  {
    name: 'Caja de Crédito Cuenca Coop. LTDA.',
    code: 'CAJA_DE_CREDITO_CUENCA_COOP_LTDA'
  },
  {
    name: 'Banco Sucredito Regional S.A.U.',
    code: 'BANCO_SUCREDITO_REGIONAL_SAU'
  },
  {
    name: 'Banco Dino S.A.',
    code: 'BANCO_DINO_SA'
  },
  {
    name: 'Compañía Financiera Argentina S.A.',
    code: 'COMPANIA_FINANCIERA_ARGENTINA_SA'
  },
  {
    name: 'Volkswagen Credit Compañía Financiera S.A.',
    code: 'VOLKSWAGEN_FINANCIAL_SERVICES_COMPANIA_FINANCIERA'
  },
  {
    name: 'Cordial Compañía Financiera S.A.',
    code: 'CORDIAL_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'Fiat Crédito Compañía Financiera S.A.',
    code: 'FCA_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'GPAT Compañía Financiera S.A.',
    code: 'GPAT_COMPANIA_FINANCIERA_SAU'
  },
  {
    name: 'Mercedes-Benz Compañía Financiera Argentina S.A.',
    code: 'MERCEDES_BENZ_COMPANIA_FINANCIERA_ARGENTINA'
  },
  {
    name: 'Rombo Compañía Financiera S.A.',
    code: 'ROMBO_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'John Deere Credit Compañía Financiera S.A.',
    code: 'JOHN_DEERE_CREDIT_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'PSA Finance Argentina Compañía Financiera S.A.',
    code: 'PSA_FINANCE_ARGENTINA_COMPANIA_FINANCIERA'
  },
  {
    name: 'Toyota Compañía Financiera de Argentina S.A.',
    code: 'TOYOTA_COMPANIA_FINANCIERA_DE_ARGENTINA'
  },
  {
    name: 'Naranja X',
    code: 'NARANJA_DIGITAL_COMPANIA_FINANCIERA_SA'
  },
  {
    name: 'Provincanje S.A.',
    code: 'PROVINCANJE_SA'
  },
  {
    name: 'Onda Siempre Podes Comprar',
    code: 'ONDA_SIEMPRE_PODES_COMPRAR'
  },
  {
    name: 'Mercado Pago',
    code: 'MERCADO_LIBRE_SRL'
  },
  {
    name: 'Administradora San Juan SA',
    code: 'ADMINISTRADORA_SAN_JUAN_SA'
  },
  {
    name: 'Ualá',
    code: 'UALA'
  },
  {
    name: 'Mobbex',
    code: 'MOBBEX'
  },
  {
    name: 'MIIII SA',
    code: 'MIIII_SA'
  },
  {
    name: 'Invoition',
    code: 'INVOITION'
  },
  {
    name: 'Prex',
    code: 'PREX'
  },
  {
    name: 'Naranja Cuenta',
    code: 'NARANJA_CUENTA'
  },
  {
    name: 'MYHNT SRL',
    code: 'MYHNT_SRL'
  },
  {
    name: 'Wibond Argentina',
    code: 'WIBOND_ARGENTINA'
  },
  {
    name: 'TdkLabs',
    code: 'TDKLABS'
  },
  {
    name: 'CAME Pagos',
    code: 'CAME_PAGOS'
  },
  {
    name: 'Remitee',
    code: 'REMITEE'
  },
  {
    name: 'Allaria +',
    code: 'ALLARIA_PLUS'
  },
  {
    name: 'Nvio Pagos Argentina SAU',
    code: 'NVIO_PAGOS_ARGENTINA_SAU'
  },
  {
    name: 'Paymovil',
    code: 'PAYMOVIL'
  },
  {
    name: 'Nubi',
    code: 'NUBI'
  },
  {
    name: 'Resimple',
    code: 'RESIMPLE'
  },
  {
    name: 'BKR',
    code: 'BKR'
  },
  {
    name: 'TAP Billetera',
    code: 'TAP_BILLETERA'
  },
  {
    name: 'Farmacloud',
    code: 'FARMACLOUD'
  },
  {
    name: 'CuentaDigital.com',
    code: 'CUENTADIGITAL_COM'
  },
  {
    name: 'Credi Si Online',
    code: 'CREDI_SI_ONLINE'
  },
  {
    name: 'Telepagos',
    code: 'TELEPAGOS'
  },
  {
    name: 'Pago Virtual del Sur SA',
    code: 'PAGO_VIRTUAL_DEL_SUR_SA'
  },
  {
    name: 'Waynicoin S.A.',
    code: 'WAYNICOIN_SA'
  },
  {
    name: 'Airata SA',
    code: 'AIRATA_SA'
  },
  {
    name: 'Yacaré',
    code: 'YACARE'
  },
  {
    name: 'Agilpagos',
    code: 'AGILPAGOS'
  },
  {
    name: 'Chronoswallet SA',
    code: 'CHRONOSWALLET_SA'
  },
  {
    name: 'Bull Pay',
    code: 'BULL_PAY'
  },
  {
    name: 'Processing Data Argentina SA',
    code: 'PROCESSING_DATA_ARGENTINA_SA'
  },
  {
    name: '3SM SA',
    code: 'TRES_SM_SA'
  },
  {
    name: 'PayCloud',
    code: 'PAYCLOUD'
  },
  {
    name: 'API Pagos',
    code: 'API_PAGOS'
  },
  {
    name: 'Cumar SA',
    code: 'CUMAR_SA'
  },
  {
    name: 'Garpa SA',
    code: 'GARPA_SA'
  },
  {
    name: 'Moni',
    code: 'MONI'
  },
  {
    name: 'Propago Argentina S.R.L.',
    code: 'PROPAGO_ARGENTINA_SRL'
  },
  {
    name: 'Micro Sistemas S.A.U.',
    code: 'MICRO_SISTEMAS_SAU'
  },
  {
    name: 'Bizland Payment Solutions',
    code: 'BIZLAND_PAYMENT_SOLUTIONS'
  },
  {
    name: 'Billetera Fertil Finanzas SA',
    code: 'BILLETERA_FERTIL_FINANZAS_SA'
  },
  {
    name: 'Pagos360',
    code: 'PAGOS360'
  },
  {
    name: 'Billetera Sos Genial',
    code: 'BILLETERA_SOS_GENIAL'
  },
  {
    name: 'ALZ Mercados S.A.',
    code: 'ALZ_MERCADOS_SA'
  },
  {
    name: 'Makeke SAS',
    code: 'MAKEKE_SAS'
  },
  {
    name: 'Claro Pay',
    code: 'CLARO_PAY'
  },
  {
    name: 'Bica Ágil',
    code: 'BICA_AGIL'
  },
  {
    name: 'Billetera Palta SAS',
    code: 'BILLETERA_PALTA_SAS'
  },
  {
    name: 'Taca Taca',
    code: 'TACA_TACA'
  },
  {
    name: 'Servicios Urbanos',
    code: 'SERVICIOS_URBANOS'
  },
  {
    name: 'RGM',
    code: 'RGM'
  },
  {
    name: 'NEG Argentina SRL',
    code: 'NEG_ARGENTINA_SRL'
  },
  {
    name: 'Rebit',
    code: 'REBIT'
  },
  {
    name: 'Pagotic',
    code: 'PAGOTIC'
  },
  {
    name: 'Bolsillo Digital',
    code: 'BOLSILLO_DIGITAL'
  },
  {
    name: 'viuMi',
    code: 'VIUMI'
  },
  {
    name: 'Billetera Bamba SA',
    code: 'BILLETERA_BAMBA_SA'
  },
  {
    name: 'Tucash',
    code: 'TUCASH'
  },
  {
    name: 'COIN Cobro Inmediato',
    code: 'COIN_COBRO_INMEDIATO'
  },
  {
    name: 'Billetera Pagos Online',
    code: 'BILLETERA_PAGOS_ONLINE'
  },
  {
    name: 'Billetera Benkopay S.A.S.',
    code: 'BILLETERA_BENKOPAY_SAS'
  },
  {
    name: 'ePagos SA',
    code: 'EPAGOS_SA'
  },
  {
    name: 'C Tech',
    code: 'C_TECH'
  },
  {
    name: 'más Pagos Nación',
    code: 'MAS_PAGOS_NACION'
  },
  {
    name: 'Billetera BilleteraPais SA',
    code: 'BILLETERA_BILLETERAPAIS_SA'
  },
  {
    name: 'Payfun',
    code: 'PAYFUN'
  },
  {
    name: 'Servicios de Pago',
    code: 'SERVICIOS_DE_PAGO'
  },
  {
    name: 'Helipagos',
    code: 'HELIPAGOS'
  },
  {
    name: 'Paxsys',
    code: 'PAXSYS'
  },
  {
    name: 'Recargas Electrónicas SA',
    code: 'RECARGAS_ELECTRONICAS_SA'
  },
  {
    name: 'Sistema de Pagos Costa Atlántica SA',
    code: 'SISTEMA_DE_PAGOS_COSTA_ATLANTICA_SA'
  },
  {
    name: 'Digypayments',
    code: 'DIGYPAYMENTS'
  },
  {
    name: 'Openpay Argentina',
    code: 'OPENPAY_ARGENTINA'
  },
  {
    name: 'Pomelo',
    code: 'POMELO'
  },
  {
    name: 'Urbana',
    code: 'URBANA'
  },
  {
    name: 'Efectivo Digital',
    code: 'EFECTIVO_DIGITAL'
  },
  {
    name: 'Movimiento MKT S.R.L',
    code: 'MOVIMIENTO_MKT_SRL'
  },
  {
    name: 'Lohas SAS',
    code: 'LOHAS_SAS'
  },
  {
    name: 'IBBA Group SRL',
    code: 'IBBA_GROUP_SRL'
  },
  {
    name: 'Xcoop Argentina S.A.',
    code: 'XCOOP_ARGENTINA_SA'
  },
  {
    name: 'Xcard Argentina S.A.',
    code: 'XCARD_ARGENTINA_SA'
  },
  {
    name: 'Full Access SA',
    code: 'FULL_ACCESS_SA'
  },
  {
    name: 'Neblockchain SA',
    code: 'NEBLOCKCHAIN_SA'
  },
  {
    name: '365 Debit S.A.',
    code: 'TRESCIENTOS_SESENTA_CINCO_DEBIT_SA'
  },
  {
    name: 'Lemon (Digifin SA)',
    code: 'LEMON_DIGIFIN_SA'
  },
  {
    name: 'Credencial',
    code: 'CREDENCIAL'
  },
  {
    name: 'Fersi',
    code: 'FERSI'
  },
  {
    name: 'Masstrading S.A.',
    code: 'MASSTRADING_SA'
  },
  {
    name: 'Conexión de Altura SA',
    code: 'CONEXION_DE_ALTURA_SA'
  },
  {
    name: 'Qwerty S.A.',
    code: 'QWERTY_SA'
  },
  {
    name: 'N Co Pay Servicios Financieros y Tecnológicos en Pagos Electrónicos SRL',
    code: 'N_CO_PAY_SER_FIN_Y_TEC_EN_PAG_ELECTR_SRL'
  },
  {
    name: 'Bind Pagos',
    code: 'BIND_PAGOS'
  },
  {
    name: 'Sociedad del Estado Casa de Moneda S.A.',
    code: 'SOCIEDAD_DEL_ESTADO_CASA_DE_MONEDA_SA'
  },
  {
    name: 'Billetera Morphyng SA',
    code: 'BILLETERA_MORPHYNG_SA'
  },
  {
    name: 'Linkingpos',
    code: 'LINKINGPOS'
  },
  {
    name: 'Soluciones de Pago SA',
    code: 'SOLUCIONES_DE_PAGO_SA'
  },
  {
    name: 'Tera',
    code: 'TERA'
  },
  {
    name: 'n1u',
    code: 'N1U'
  },
  {
    name: 'E-Cobro',
    code: 'E_COBRO'
  },
  {
    name: 'Ya Ganaste',
    code: 'YA_GANASTE'
  },
  {
    name: 'Evwebpay',
    code: 'EVWEBPAY'
  },
  {
    name: 'Balanz Payments SAU',
    code: 'BALANZ_PAYMENTS_SAU'
  },
  {
    name: 'Más Simple SA',
    code: 'MAS_SIMPLE_SA'
  },
  {
    name: 'FCM Payment Solutions SAS',
    code: 'FCM_PAYMENT_SOLUTIONS_SAS'
  },
  {
    name: 'Insight Business',
    code: 'INSIGHT_BUSINESS'
  },
  {
    name: 'Polux Capitals S.A.',
    code: 'POLUX_CAPITALS_SA'
  },
  {
    name: 'Agripay SA',
    code: 'AGRIPAY_SA'
  },
  {
    name: 'Pago24',
    code: 'PAGO24'
  },
  {
    name: 'Global66',
    code: 'GLOBAL66'
  },
  {
    name: 'Plus Billetera',
    code: 'PLUS_BILLETERA'
  },
  {
    name: 'Farmapay SA',
    code: 'FARMAPAY_SA'
  },
  {
    name: 'Mecaenpol SRL',
    code: 'MECAENPOL_SRL'
  },
  {
    name: 'Bnka',
    code: 'BNKA'
  },
  {
    name: 'Click+',
    code: 'CLICK_PLUS'
  },
  {
    name: 'Koipay',
    code: 'KOIPAY'
  },
  {
    name: 'Fiwind Pay',
    code: 'FIWIND_PAY'
  },
  {
    name: 'APG Advisors SA',
    code: 'APG_ADVISORS_SA'
  },
  {
    name: 'Sidom Pay SA',
    code: 'SIDOM_PAY_SA'
  },
  {
    name: 'Momentum',
    code: 'MOMENTUM'
  },
  {
    name: 'Pagotech',
    code: 'PAGOTECH'
  },
  {
    name: 'Ini',
    code: 'INI'
  },
  {
    name: 'Data 2000 SA',
    code: 'DATA_2000_SA'
  },
  {
    name: 'New Finance',
    code: 'NEW_FINANCE'
  },
  {
    name: 'Grupo Panda SRL',
    code: 'GRUPO_PANDA_SRL'
  },
  {
    name: 'Yont',
    code: 'YONT'
  },
  {
    name: 'Cardcred',
    code: 'CARDCRED'
  },
  {
    name: 'Go Pay S.A.S.',
    code: 'GO_PAY_SAS'
  },
  {
    name: 'Unex',
    code: 'UNEX'
  },
  {
    name: 'Forty',
    code: 'FORTY'
  },
  {
    name: 'Ikerpay SA',
    code: 'IKERPAY_SA'
  },
  {
    name: 'Evapar',
    code: 'EVAPAR'
  }
]

export const chileanBanksData = [
  {
    name: 'Banco de Chile',
    code: 'BANCODECHILE'
  },
  {
    name: "Banco O'Higgins",
    code: 'BANCO_OHIGGINS'
  },
  {
    name: 'Banco Internacional',
    code: 'BANCOINTERNACIONAL'
  },
  {
    name: 'Banco Osorno y La Unión',
    code: 'BANCO_OSORNO_Y_LA_UNION'
  },
  {
    name: 'Dresdner Bank Lateinamerica',
    code: 'DRESDNER_BANK_LATEINAMERICA'
  },
  {
    name: 'Banco del Estado de Chile',
    code: 'BANCODELESTADODECHILE'
  },
  {
    name: 'Scotiabank Chile',
    code: 'SCOTIABANKCHILE'
  },
  {
    name: 'Banco de Crédito e Inversiones',
    code: 'BANCODECREDITOEINVERSIONES'
  },
  {
    name: 'Banco do Brasil S.A.',
    code: 'BANCO_DO_BRASIL'
  },
  {
    name: 'Banco Central de Chile',
    code: 'BANCO_CENTRAL_DE_CHILE'
  },
  {
    name: 'Corpbanca',
    code: 'BANCO_CORPBANCA'
  },
  {
    name: 'Banco Bice',
    code: 'BANCOBICE'
  },
  {
    name: 'Banco de A. Edwards',
    code: 'BANCO_EDWARDS_CITI'
  },
  {
    name: 'HSBC Bank Chile',
    code: 'HSBCBANKCHILE'
  },
  {
    name: 'Bank of America N.T and S.A.',
    code: 'BANK_OF_AMERICA'
  },
  {
    name: 'Citibank N.A.',
    code: 'CITIBANK'
  },
  {
    name: 'Banco Real S.A.',
    code: 'BANCO_REAL'
  },
  {
    name: 'Banco Santiago',
    code: 'BANCO_SANTIAGO'
  },
  {
    name: 'Banco do Estado de São Paulo',
    code: 'BANCO_DO_ESTADO_DE_SAO_PAUL'
  },
  {
    name: 'Banco Santander Chile',
    code: 'SANTANDER'
  },
  {
    name: 'Banco Exterior Chile',
    code: 'BANCO_EXTERIOR_CHILE'
  },
  {
    name: 'Banco Itaú Chile',
    code: 'BANCOITAUCHILE'
  },
  {
    name: 'Banco Sudameris',
    code: 'BANCO_SUDAMERIS'
  },
  {
    name: 'JP Morgan Chase Bank',
    code: 'JP_MORGAN_CHASE_BANK'
  },
  {
    name: 'American Express Bank Ltd.',
    code: 'AMERICAN_EXPRESS_BANK'
  },
  {
    name: 'Banco de la Nación Argentina',
    code: 'BANCO_NACION_ARGENTINA'
  },
  {
    name: 'MUFG Bank',
    code: 'MUFG_BANK'
  },
  {
    name: 'The Bank of Tokyo-Mitsubishi UFJ, Ltd.',
    code: 'THE_BANK_OF_TOKYO_MITSUBISHI'
  },
  {
    name: 'The Royal Bank of Scotland Chile',
    code: 'THE_ROYAL_BANK_OF_SCOTLAND'
  },
  {
    name: 'Centro Banco',
    code: 'CENTRO_BANCO'
  },
  {
    name: 'Banco Security',
    code: 'BANCOSECURITY'
  },
  {
    name: 'Banco Shangay',
    code: 'BANCO_SHANGAY'
  },
  {
    name: 'Banco Falabella',
    code: 'BANCOFALABELLA'
  },
  {
    name: 'Deutsche Bank Chile',
    code: 'DEUTSCHE_BANK_CHILE'
  },
  {
    name: 'Banco Ripley',
    code: 'BANCORIPLEY'
  },
  {
    name: 'Rabobank Chile',
    code: 'RABOBANK_CHILE'
  },
  {
    name: 'Banco Consorcio',
    code: 'BANCOCONSORCIO'
  },
  {
    name: 'Banco Paris',
    code: 'BANCO_PARIS'
  },
  {
    name: 'DNB Nor Bank ASA',
    code: 'DNB_NOR_BANK_ASA'
  },
  {
    name: 'Banco BTG Pactual Chile',
    code: 'BANCOBTGPACTUALCHILE'
  },
  {
    name: 'Banco Bilbao Vizcaya Argentaria Chile',
    code: 'BBVA'
  },
  {
    name: 'Banco del Desarrollo',
    code: 'BANCO_DESARROLLO'
  },
  {
    name: 'Coopeuch',
    code: 'COOPEUCH'
  },
  {
    name: 'Inversiones La Polar',
    code: 'INVERSIONES_LA_POLAR'
  },
  {
    name: 'Financiera Atlas',
    code: 'FINANCIERA_ATLAS'
  },
  {
    name: 'Prepago Los Héroes',
    code: 'PREPAGO_LOS_HEROES'
  },
  {
    name: 'Tenpo Payments',
    code: 'TENPO_PAYMENTS'
  },
  {
    name: 'Tapp Caja Los Andes',
    code: 'TAPP_CAJA_LOS_ANDES'
  },
  {
    name: 'Financiera Condell',
    code: 'FINANCIERA_CONDELL'
  },
  {
    name: 'Banco Conosur',
    code: 'BANCO_CONOSUR'
  },
  {
    name: 'Global66',
    code: 'GLOBAL66'
  },
  {
    name: 'Copec Pay',
    code: 'COPEC_PAY'
  },
  {
    name: 'Mercado Pago',
    code: 'MERCADO_PAGO'
  },
  {
    name: 'CrediChile',
    code: 'CREDI_CHILE'
  },
  {
    name: 'Tbanc',
    code: 'TBANC'
  },
  {
    name: 'Banefe',
    code: 'BANEFE'
  },
  {
    name: 'China Construction Bank',
    code: 'CHINACONSTRUCTIONBANKAGENCIAENCHILE'
  },
  {
    name: 'Bank of China',
    code: 'BANKOFCHINAAGENCIAENCHILE'
  }
]

export const peruBanksData = [
  {
    name: 'Banco Central de Reserva del Perú',
    code: 'BANCO_CENTRAL_RESERVA_DEL_PERU'
  },
  {
    name: 'Banco de Crédito del Perú',
    code: 'CREDITO'
  },
  {
    name: 'Interbank',
    code: 'INTERBANK'
  },
  {
    name: 'Citibank',
    code: 'CITIBANK'
  },
  {
    name: 'Scotiabank Perú',
    code: 'SCOTIABANK'
  },
  {
    name: 'BBVA Perú',
    code: 'BBVA_PERU'
  },
  {
    name: 'Banco de la Nación',
    code: 'NACION'
  },
  {
    name: 'Banco de Comercio',
    code: 'COMERCIO'
  },
  {
    name: 'Banco Pichincha',
    code: 'PICHINCHA'
  },
  {
    name: 'Banco Interamericano de Finanzas',
    code: 'BIF'
  },
  {
    name: 'CrediScotia Financiera',
    code: 'CREDISCOTIA'
  },
  {
    name: 'MiBanco',
    code: 'MI_BANCO'
  },
  {
    name: 'Banco Agropecuario',
    code: 'AGROBANCO'
  },
  {
    name: 'Fondo Mivivienda',
    code: 'MI_VIVIENDA'
  },
  {
    name: 'Banco GNB Perú',
    code: 'GNB'
  },
  {
    name: 'Banco Falabella',
    code: 'FALABELLA'
  },
  {
    name: 'Banco Ripley',
    code: 'RIPLEY'
  },
  {
    name: 'Banco Santander Perú',
    code: 'SANTANDER'
  },
  {
    name: 'Banco Azteca',
    code: 'AZTECA'
  },
  {
    name: 'CRAC CAT',
    code: 'CRAC_CAT_SA'
  },
  {
    name: 'ICBC Peru Bank',
    code: 'ICBC'
  },
  {
    name: 'JP Morgan',
    code: 'JPMORGAN'
  },
  {
    name: 'Corporación Financiera de Desarrollo',
    code: 'COFIDE'
  },
  {
    name: 'Financiera Credinka',
    code: 'FIN_CREDINKA'
  },
  {
    name: 'Compartamos Financiera',
    code: 'COMPARTAMOS_FIN'
  },
  {
    name: 'Financiera Qapaq',
    code: 'FIN_QAPAQ'
  },
  {
    name: 'Financiera Oh! S.A.',
    code: 'FIN_OH'
  },
  {
    name: 'Financiera Amérika',
    code: 'AMERICA_FIN'
  },
  {
    name: 'Financiera Efectiva',
    code: 'FIN_EFECTIVA'
  },
  {
    name: 'Financiera Mitsui',
    code: 'FIN_MITSUI'
  },
  {
    name: 'Financiera Proempresa',
    code: 'FIN_PROEMPRESA'
  },
  {
    name: 'Financiera Confianza',
    code: 'FIN_CONFIANZA'
  },
  {
    name: 'Cavali',
    code: 'CAVALI'
  },
  {
    name: 'Caja Metropolitana de Lima',
    code: 'CAJA_METROPOLITANA_DE_LIMA'
  },
  {
    name: 'CMAC Piura',
    code: 'CMAC_PIURA'
  },
  {
    name: 'Caja Municipal de Trujillo',
    code: 'CAJA_MUNICIPAL_DE_TRUJILLO'
  },
  {
    name: 'Caja Municipal de Arequipa',
    code: 'CAJA_MUNICIPAL_AREQUIPA'
  },
  {
    name: 'CMAC Sullana',
    code: 'CMAC_SULLANA'
  },
  {
    name: 'CMAC Cusco',
    code: 'CMAC_CUZCO'
  },
  {
    name: 'CMAC Santa',
    code: 'CMAC_SANTA'
  },
  {
    name: 'CMAC Huancayo',
    code: 'CMAC_HUANCAYO'
  },
  {
    name: 'CMAC Ica',
    code: 'CMAC_ICA'
  },
  {
    name: 'CMAC Paita',
    code: 'CMAC_PAITA'
  },
  {
    name: 'CMAC Maynas',
    code: 'CMAC_MAYNAS'
  },
  {
    name: 'CMAC Tacna',
    code: 'CMAC_TACNA'
  },
  {
    name: 'Crediraíz',
    code: 'CREDIRAIZ'
  },
  {
    name: 'Caja Sipán',
    code: 'CAJA_SIPAN'
  },
  {
    name: 'Caja Los Andes',
    code: 'CAJA_LOS_ANDES'
  },
  {
    name: 'Caja Rural Prymera',
    code: 'CAJA_RURAL_PRYMERA'
  },
  {
    name: 'Incasur',
    code: 'INCASUR'
  },
  {
    name: 'Caja Centro',
    code: 'CAJA_CENTRO'
  },
  {
    name: 'Ligo Payments',
    code: 'LIGO'
  }
]
